import { call, put, takeEvery } from "redux-saga/effects";
import * as actions from "actions/accessCard";
import { apiPost, apiGet, apiDelete, apiPut } from "sagas/callApi";

function* createOne(api, { payload, meta }) {
  try {
    const { data, token } = payload;
    let resp;
    if (token) {
      resp = yield call(apiPost, api, `/access_card/${token}`, data, true);
    } else {
      resp = yield call(apiPost, api, `/access_card`, data, true);
    }
    yield put(actions.createOneSuccess(resp.data, meta));
  } catch (e) {
    yield put(actions.createOneFailed(e, meta));
  }
}

function* fetchAll(api) {
  try {
    const resp = yield call(apiGet, api, `/access_card`, null, true);
    yield put(actions.fetchAllSuccess(resp.data));
  } catch (e) {
    yield put(actions.fetchAllFailed(e));
  }
}

function* deleteOne(api, { payload, meta }) {
  try {
    const { id } = payload;
    yield call(apiDelete, api, `/access_card/${id}`, null, true);
    yield put(actions.deleteOneSuccess(id, meta));
  } catch (e) {
    yield put(actions.deleteOneFailed(e.response.data.error, meta));
  }
}

function* updateOne(api, { payload, meta }) {
  try {
    const { data, id } = payload;
    const resp = yield call(apiPut, api, `/access_card/${id}`, data, true);
    yield put(actions.updateOneSuccess(resp.data, meta));
  } catch (e) {
    yield put(actions.updateOneFailed(e, meta));
  }
}

export default function* rootSaga({ api }) {
  yield takeEvery(actions.DELETE_ONE, deleteOne, api);
  yield takeEvery(actions.CREATE_ONE, createOne, api);
  yield takeEvery(actions.UPDATE_ONE, updateOne, api);
  yield takeEvery(actions.FETCH_ALL, fetchAll, api);
}



// WEBPACK FOOTER //
// ./src/sagas/accessCard.js